import { Box } from "@mui/material";
import { CreateNewContent, CreateNewPage } from "@platformx/content";
import {
  capitalizeWords,
  DashboardCardLoader,
  ErrorTooltip,
  NoSearchResult,
  useAccess,
} from "@platformx/utilities";
import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Card from "./Card";
import { useCustomStyle } from "./cart.style";
import { SETTINGS } from "./utils/constants";
import { getBgColorArray } from "./utils/helper";

type CardSliderProps = {
  createContent: any;
  loading?: boolean;
};
const CardSlider = ({ createContent, loading }: CardSliderProps) => {
  const colorList = getBgColorArray(createContent?.length) || "";
  const classes = useCustomStyle();
  const [createPage, setCreatePage] = useState<boolean>(false);
  const [openCreateContent, setOpenCreateContent] = useState<boolean>(false);
  const { canAccessAction } = useAccess();
  const [contentType, setContentType] = useState<string>("Article");
  /**
   * navigate to page or another contentType
   * @param params object
   */
  const handleCardClick = (params: any) => {
    const { CTAText = "", url } = params;
    if (CTAText.toLowerCase().includes("create a page")) {
      setCreatePage(!createPage);
    } else {
      const type = url?.split("-").pop();
      setContentType(type);
      setOpenCreateContent(true);
    }
  };

  const closeButtonHandle = () => {
    setOpenCreateContent(false);
  };
  const canAccessCard = (url) => {
    //NEED to renmoved when api will give category and subcategory
    //TEMP HACK
    const type = url?.split("-").pop();
    if (type && type.length > 1) {
      return !canAccessAction("content", type, "create");
    } else {
      return !canAccessAction("Page", "SitePage", "create");
    }
  };

  return (
    <>
      {loading ? (
        <DashboardCardLoader />
      ) : createContent?.length > 0 ? (
        <Slider {...SETTINGS} className={`${classes.dashboardCardSlider} CardSliderDashboard`}>
          {createContent.map((item: any, index: number) => {
            const hasAccsees = canAccessCard(item.url);
            return (
              item.url !== "" && (
                <ErrorTooltip
                  key={index}
                  position='top'
                  component={
                    <Box
                      sx={{
                        pointerEvents: hasAccsees ? "none" : "auto",
                        opacity: hasAccsees ? 0.3 : 1,
                        cursor: hasAccsees ? "not-allowed" : "pointer",
                      }}>
                      <Card
                        handleCardClick={handleCardClick}
                        ImageUrl={item?.image_1.ImageCropUrl?.CropUrl.Web}
                        BgColor={colorList[index]}
                        CTAText={capitalizeWords(item?.title)}
                        url={item.url}
                      />
                    </Box>
                  }
                  doAccess={hasAccsees}
                />
              )
            );
          })}
        </Slider>
      ) : (
        <NoSearchResult />
      )}

      {/* create new page from dashboard */}
      {createPage && (
        <CreateNewPage
          isDialogOpen={createPage}
          closeButtonHandle={() => setCreatePage(!createPage)}
        />
      )}
      {openCreateContent ? (
        <CreateNewContent
          isDialogOpen={true}
          closeButtonHandle={closeButtonHandle}
          contentType={contentType}
          category='Content'
        />
      ) : null}
    </>
  );
};

export default CardSlider;
